import { useState } from 'react';

export enum PayoutTabValues {
  All = 'all',
  Paid = 'paid',
  Failed = 'failed',
  Pending = 'pending',
}

export enum PayoutColumn {
  bank = 'Bank',
  ibanLast4 = '4 Digits',
  initiationDate = 'Initiation Date',
  amount = 'Amount',
  transferDate = 'TransferDate',
  status = 'Status',
  type = 'Type',
  reconciliation = 'Reconciliation',
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useAccountingPayoutsPage = () => {
  const [tabFilterValue, setTabFilterValue] = useState<PayoutTabValues>(
    PayoutTabValues.All
  );

  return {
    tabFilterValue,
    setTabFilterValue,
  };
};
